import { render, staticRenderFns } from "./pronoun.vue?vue&type=template&id=dafde5c2&"
import script from "./pronoun.vue?vue&type=script&lang=js&"
export * from "./pronoun.vue?vue&type=script&lang=js&"
import style0 from "./pronoun.vue?vue&type=style&index=0&id=dafde5c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports